import { render, staticRenderFns } from "./healthService.vue?vue&type=template&id=0544c8c4&scoped=true"
import script from "./healthService.vue?vue&type=script&lang=js"
export * from "./healthService.vue?vue&type=script&lang=js"
import style0 from "./healthService.vue?vue&type=style&index=0&id=0544c8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0544c8c4",
  null
  
)

export default component.exports